import React from 'react';
import './SkillCategory.css';

const SkillCategory = ({ title, subtitle, icon, color, tools, delay, isVisible }) => {
  return (
    <div
      className={`skill-category ${isVisible ? 'visible' : ''} ${color}`}
      style={{ animationDelay: `${delay}s` }}
    >
      <div className="category-header">
        <div className="category-icon">
          <span className="icon-emoji">{icon}</span>
        </div>
        <div className="category-info">
          <h3 className="category-title">{title}</h3>
          <p className="category-subtitle">{subtitle}</p>
        </div>
      </div>

      <div className="tools-grid">
        {tools.map((tool, index) => (
          <div key={index} className="tool-item">
            <div className="tool-header">
              <h4 className="tool-name">{tool.name}</h4>
            </div>
            <p className="tool-description">{tool.description}</p>
          </div>
        ))}
      </div>
    </div>
  );
};

export default SkillCategory;